import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TooltipCoordinatorService {
  private activeTooltip: string | null = null;

  setActiveTooltip(key: string): boolean {
    const wasChanged = this.activeTooltip !== key;
    this.activeTooltip = key;
    return wasChanged;
  }

  isTooltipVisible(key: string): boolean {
    return this.activeTooltip === key;
  }

  hideAllTooltips(): void {
    this.activeTooltip = null;
    this.restoreHoverTooltips();
  }

  getActiveTooltip(): string | null {
    return this.activeTooltip;
  }

  private disableHoverTooltips(): void {
    const infoButtons = document.querySelectorAll('.info-btn[title]');
    infoButtons.forEach(button => {
      const titleValue = button.getAttribute('title');
      if (titleValue) {
        button.setAttribute('data-original-title', titleValue);
        button.removeAttribute('title');
      }
    });
  }

  private restoreHoverTooltips(): void {
    const infoButtons = document.querySelectorAll('.info-btn[data-original-title]');
    infoButtons.forEach(button => {
      const originalTitle = button.getAttribute('data-original-title');
      if (originalTitle) {
        button.setAttribute('title', originalTitle);
        button.removeAttribute('data-original-title');
      }
    });
  }

  handleInfoClick(evt: MouseEvent, tooltipKey: string, infoTexts: { [key: string]: string }): void {
    evt.stopPropagation();
    
    if (tooltipKey) {
      if (this.activeTooltip === tooltipKey) {
        this.hideAllTooltips();
      } else {
        this.activeTooltip = tooltipKey;
        this.disableHoverTooltips();
      }
    }
  }
}